import {
  setRadiationEvaluationInSamples,
  setSafetyEvaluationInSamples,
} from '@/helpers/evaluation/safetyRadiationEvaluation';

/* eslint-disable camelcase */

function setTechnicalInhouseGradeData(proposals) {
  return proposals.map((proposal) => {
    // temporary change - to delete when changing cryo RA inhouse_grade into technical_evaluation
    if (proposal.document_specification.type === 'cryoem') {
      const { inhouse_grade = {} } = proposal;
      inhouse_grade.comment = inhouse_grade.states?.name === 'submitted'
        ? inhouse_grade.comment
        : '';
      inhouse_grade.acceptance_mark = inhouse_grade.states?.name === 'submitted'
        ? inhouse_grade.acceptance_mark
        : '';
      return { ...proposal, inhouse_grade };
    }
    // end of temporary change
    const { technical_evaluation = {} } = proposal;
    technical_evaluation.comments = technical_evaluation.states?.name === 'submitted'
      ? technical_evaluation.comments
      : '';
    technical_evaluation.feasibility = technical_evaluation.states?.name === 'submitted'
      ? technical_evaluation.feasibility
      : '';
    return { ...proposal, technical_evaluation };
  });
}

function setDataInProposalsSafety(proposals, authors) {
  let proposalsWithData = setSafetyEvaluationInSamples(proposals, authors);
  proposalsWithData = setTechnicalInhouseGradeData(proposalsWithData);
  return proposalsWithData;
}

function setDataInProposalsRadiation(proposals, authors) {
  let proposalsWithData = setRadiationEvaluationInSamples(proposals, authors);
  proposalsWithData = setTechnicalInhouseGradeData(proposalsWithData);
  return proposalsWithData;
}

export {
  setDataInProposalsSafety,
  setDataInProposalsRadiation,
};
